import React from 'react'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import MDefaultform from '../m_defaultForm'

const MSuggestTopic = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier

  return (
    <MDefaultform
      buttonLabel="Thema anstoßen"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
      shouldPersist={true} // Signals backend to persist the form data in db
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbRte add_class="m-Formblock-text" text={data.text} />}

          <div className="m-Formblock-input dfb-Input--multiline">
            <DfbInputTextarea
              {...register('suggestion', {
                required: t('form.errorMessage.input'),
              })}
              maxLength={200}
              error={!!errors.suggestion}
              errorMessage={errors?.suggestion?.message}
              placeholder="Egal ob VAR, Saudi-Arabien, Jugendfußball oder Pyro - sag uns die Meinung in Deinen Worten."
              tagName="textarea"
            />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MSuggestTopic
